import React from 'react';
import './SectionHeader.css';

/**
 * Baustein 2 — Section-Header.
 * Label über einer Region. Kein Container, kein Rahmen.
 * Wird auch als Panel-, Form- und Tabellen-Header verwendet.
 *
 *   <SectionHeader size="sm" count={762}>Alle Prints</SectionHeader>   → „ALLE PRINTS · 762“
 *
 * Props:
 *   children   — Label-Text (wird intern uppercase gerendert)
 *   count      — optionale Anzahl; steht direkt hinter dem Label in derselben Zeile als „· N“
 *                (gedämpft, deutsch formatiert: 1.234). `0` wird gezeigt, `null`/weggelassen nicht.
 *                Für Zahlen gedacht, die zum Label gehören — nicht über `action`.
 *   action     — optionale rechtsbündige Aktion (Text-Link)
 *   divider    — boolean, ob border-bottom angezeigt wird (default false)
 *   size       — 'md' (default) | 'sm'. `sm` = kleinere Hierarchiestufe für
 *                Sub-Header innerhalb einer Section (z.B. „Eingehend" /
 *                „Gesendet" oder Detail-Panel-Abschnitte): kleiner, gedämpft,
 *                kompakteres Spacing.
 */
export default function SectionHeader({ children, count = null, action, divider = false, size = 'md' }) {
  const cls = [
    'section-header',
    size === 'sm' && 'section-header--sm',
    divider && 'section-header--divided',
  ].filter(Boolean).join(' ');
  return (
    <div className={cls}>
      <span className="section-header__label">
        {children}
        {count != null && <>{' '}<span className="section-header__count">· {count.toLocaleString('de-DE')}</span></>}
      </span>
      {action && <span className="section-header__action">{action}</span>}
    </div>
  );
}
